import { Routes } from '@angular/router';

import { CompaniesListPageComponent } from './pages/companies-list-page/companies-list-page.component';
import { DashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { LoginGuard } from './shared/guards/login.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginPageComponent,
    canActivate: [LoginGuard],
  },
  {
    path: 'dashboard',
    component: DashboardPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'companies',
    component: CompaniesListPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'pending-requests',
    loadComponent: () =>
      import('./pages/pending-requests-page/pending-requests-page.component').then(
        (m) => m.PendingRequestsPageComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'reports',
    loadComponent: () =>
      import('./pages/reports-page/reports-page.component').then(
        (m) => m.ReportsPageComponent,
      ),
    canActivate: [AuthGuard],
  },
  { path: '', redirectTo: 'pending-requests', pathMatch: 'full' },
  { path: '**', redirectTo: 'pending-requests' },
];
